<template>
    <div class="layer" style="z-index: 6;" v-show="visible">
        <div class="fixedBackIcon backIcon" @click="exit()"></div>
        <tcPlayer ref="videoPlayer" :image="image" :fileID="fileID" :videoStyle="'height: 100%;'"/>
    </div>
</template>

<script>
// part and modules
import dialogPart   from '../part/dialogPart';
import tcPlayer     from "./tcPlayer";

const config = {
    name: "tcPlayerLayer",
};

export default {
    name : config.name,
    extends : dialogPart,
    components : {
        tcPlayer
    },
    props : {
        image : String,
        fileID : String
    },
    methods : {
        getPlayerControl() {
            return this.$refs.videoPlayer.getPlayerControl();
        },
        exit() {
            let playerControl = this.getPlayerControl();
            playerControl.pause();
            this.hide();
        }
    }
}
</script>

<style lang="scss" scoped>
.layer {
    background: black;
}
.backIcon {
    width: 24px;
    height: 24px;
    background-image: url('data:image/png;base64,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');

}
</style>
